import gql from 'graphql-tag';

export default gql`
  mutation CreateShop(
    $data: ShopCreateInput!
  ) {
    createShop(
      data: $data
    ) {
      id
      name
      status
      isService
      menus
      pdfs
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/CreateShop.ts